export default {"src":"/_next/static/media/gmx.0e372310.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};